import React, { useContext } from "react";

import AuthContext from "../../context/auth/authContext";

const UserPermissionReview = ({
  level,
  setLevel,
  setEdit,
  charters,
  charterAccess,
  user,
}) => {
  const authContext = useContext(AuthContext);
  const { name, azureID } = user;
  return (
    <table className="fancy-table">
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Charter Assignments</th>
        <th>Update</th>
        <th>Permission Level</th>
      </tr>
      <tr>
        <td>{name}</td>
        <td>{azureID}</td>
        <td className="form-userperm">
          {charterAccess ? (
            <p>All Charters</p>
          ) : (
            <select name="" id="">
              {charters.map((item) => {
                return <option value={item.name}>{item.name}</option>;
              })}
            </select>
          )}
        </td>
        <td>
          <div
            className={`btn btn-llac-dark-${charterAccess ? "grey" : "green"}`}
            onClick={() => {
              if (!charterAccess) {
                setEdit(true);
              }
            }}
          >
            Update Charters
          </div>
        </td>
        <td className="form-userperm">
          <select value={level} onChange={(e) => setLevel(e)}>
            <option value="">Select Level</option>
            <option value="General">Delete</option>
            <option value="User">User</option>
            <option value="Contributor">Contributor</option>
            {authContext.user && authContext.user.userStatus === "Super Admin" && (
              <>
                <option value="Admin">Admin</option>
                <option value="Super Admin">Super Admin</option>
              </>
            )}
          </select>
        </td>
      </tr>
    </table>
  );
};

export default UserPermissionReview;
